import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { TaxonomyEntry } from 'src/redux/content/types';

// Stable reference so consumers (e.g. `useSelector`) don't see a new array — and
// re-render / recompute — on every render when no map has been loaded.
const EMPTY_ENTRIES: TaxonomyEntry[] = [];

/** The neighbourhood map (`content.entries`), or a stable empty array when unset. */
export const selectContentEntries = (state: ReduxApplicationState): TaxonomyEntry[] =>
  state.content?.entries ?? EMPTY_ENTRIES;
